import React, { useEffect, useState, useCallback } from 'react';
// styles
import useStyles from "./styles";
import { Divider, Paper, AppBar, Tabs, Tab, Typography, Box, InputAdornment, Tooltip, ListItem, ListItemIcon, ListItemText, Grid, Link, TextField, CircularProgress, IconButton, Button, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, useTheme } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import MenuItem from '@material-ui/core/MenuItem';
import { FormInput } from '../../..';
import { pathOr } from "ramda";

import JSONInput from 'react-json-editor-ajrm';
import locale    from 'react-json-editor-ajrm/locale/en';

export default function AddCustomTile({ addDashlet ,data={},setCustomTileData=(()=>{})}) {

    const [customDashletType, setCustomDashletType] = useState(pathOr('Filter', ['subType'], data) );
    const dateString = Date.now().toString(36);
    const randomness = Math.random().toString(36).substr(2);
    const chartName= dateString + randomness;
    const [customDashletOptions, setCustomDashletOptions] = useState({
        'Filter': pathOr(null, ['subType'], data)==='Filter'?data: {
            type: 'custom',
            subType: 'Filter',
            isHeader:true,
            label: 'Policy Filter',
            isSubHeader: true,
            isExpandIcon:false,
            isRightText:'Enter Text',
            isRightValue:'Dummy Value',
            isSubmit:true,
            submitText:"Apply",
            isFieldLabel: false,
            data:
                [
                    {
                        "field_key": "name",
                        "name": "name",
                        "label": "Name",
                        "type": "name",
                        "value": ""
                    },
                    {
                        field_key: 'from_date',
                        name: 'from_date',
                        label: 'From Date',
                        type: 'date',
                        value: ''
                      },
                    {
                        "field_key": "currency",
                        "name": "currency",
                        "label": "Currency",
                        "type": "enum",
                        "options": {
                            "Rupees": "Rupees",
                            "Dollars": "Dollars",
                        },
                        "value": []
                    },
                ]
        },
        'Form': pathOr(null, ['subType'], data)==='Form'?data: {
            type: 'custom',
            subType: 'Form',
            isHeader:true,
            label: 'Calculator',
            isSubHeader: true,
            isExpandIcon:false,
            isRightText:'Enter Text',
            isRightValue:'Dummy Value',
            isSubmit:true,
            submitText:"Apply",
            isFieldLabel: false,
            data:
                [
                    {
                        "field_key": "name",
                        "name": "name",
                        "label": "Name",
                        "type": "name",
                        "value": ""
                    },
                    {
                        field_key: 'from_date',
                        name: 'from_date',
                        label: 'From Date',
                        type: 'date',
                        value: ''
                      },
                    {
                        "field_key": "currency",
                        "name": "currency",
                        "label": "Currency",
                        "type": "enum",
                        "options": {
                            "Rupees": "Rupees",
                            "Dollars": "Dollars",
                        },
                        "value": []
                    },
                ]
        },
        'Card': pathOr(null, ['subType'], data)==='Card'?data:{
            type: 'custom',
            subType: 'Card',
            isHeader: false,
            label: 'Goals',
            listTypeStatic: false,
            data: {
              isQuery: true,
              redirectOn: 8,
              redirectDashlet: '',
              redirectFields: [],
              grid: {
                xs: 6,
                sm: 4
              },
              query: 'SELECT * FROM `scrm_refneedtype` WHERE deleted=\'0\'',
              title:'id',
              subTitle:'needtypename',
              img:'imagePath',
              isProgress:true,
              isProgress:'id'
          
            }
          },
        'Policy List':pathOr(null, ['subType'], data)==='Policy List'?data: 
        // {
        //     type: 'custom',
        //     subType: 'Policy List',
        //     isHeader:true,
        //     label: 'Policy List',
        //     listTypeStatic:true,
        //     module:null,
        //     data: [
                
        //     ]
        // },
        {
            type: 'custom',
            subType: 'Policy List',
            isHeader: true,
            label: 'Policy List',
            listTypeStatic: true,
            module:null,
            data: [
              {
               redirectOn:2,
               lists:[ {
                  label: 'Total Amount Invested',
                  module: 'scrm_FundTransactions',
                  isQuery: true,
                  query: 'SELECT SUM(unitpriceamount) as unitpriceamount from scrm_fundtransactions f left join scrm_fundtransactions_cstm fc on f.id=fc.id_c where deleted=0',
                  field: 'unitpriceamount',
                  callbackMethod: 'getTotalAmountInvested'
                },
                {
                  label: 'Total Account Value as of [YY MM DD]',
                  module: 'scrm_PolicyList',
                  fields: {
                    name: 'Funds'
                  }
                },
                {
                  label: 'Unrealized Gain (Loss)',
                  module: 'scrm_PolicyList',
                  fields: {
                    name: 'Funds'
                  }
                }]
            },
              {
               redirectOn:3,
               lists:[  {
                  label: 'Total Life Insurance Coverage as of [MM DD YY]',
                  module: 'scrm_PolicyList',
                  fields: {
                    name: 'Funds'
                  }
                }
            ]
                }
             ,
              {
                redirectOn:4,
               lists:[ 
                {
                  label: 'Total Unit-Linked Peso Policies',
                  module: 'scrm_PolicyList',
                  fields: {
                    name: 'Funds'
                  }
                },
                {
                  label: 'Single Pay Policies',
                  module: 'scrm_PolicyList',
                  fields: {
                    name: 'Funds'
                  }
                },
                {
                  label: 'Regular Pay Policies',
                  module: 'scrm_PolicyList',
                  fields: {
                    name: 'Funds'
                  }
                }
            ]
        }
            ],
       
            result: []
          },
        'Chart': pathOr(null, ['subType'], data)==='Chart'?data:{
            type: 'custom',
            subType: 'Chart',
            isHeader:true,
            label: 'Policy Chart 1',
            data: 
                    {
                        type:'geo',
                        name:"geo_"+chartName,
                        data:{

                        }
                    },
               
        },
        'Compare': pathOr(null, ['subType'], data)==='Compare'?data:{
            type: 'custom',
            subType: 'Compare',
            isHeader:true,
            label: 'Compare Policies',
            data: {
                charts: [
                    {
                        type: 'pie',
                        name: "pie1_"+chartName,
                        data: {

                        }
                    },
                    {
                        type: 'pie',
                        name: "pie2_"+chartName,
                        data: {

                        }
                    },
                ]
            }
        },
        'Table List': pathOr(null, ['subType'], data)==='Table List'?data:{
            type: 'custom',
            subType: 'Table List',
            isHeader:true,
            isSubHeader:false,
            label: 'Policy Table List',
          
            data: {  
                module:null,
                'page[size]':5,
                'page[number]':0,
                'sort': 'name',
                fields:{
                    name:'Name',
                    date_entered:'Date Entered'
                }
                
            }
        },
        'Progress Bar':pathOr(null, ['subType'], data)==='Progress Bar'?data: {
            type: 'custom',
            subType: 'Progress Bar',
            isHeader:true,
            label: 'Risk Value',
            isHelpText:true,
            HelpDescription:"Risk Value Description",
            data: []
        },
        'Custom Reports': pathOr(null, ['subType'], data)==='Custom Reports'?data:{
            type: 'custom',
            subType: 'Custom Reports',
            isHeader:true,
            isSubHeader:false,
            label: 'Policy Reports',
          
            data: [  
                {
                    label: 'Investment Holding Summary',
                    isQuery: true,
                    isApi:false,
                    query: 'SELECT SUM(unitpriceamount) as unitpriceamount from scrm_fundtransactions f left join scrm_fundtransactions_cstm fc on f.id=fc.id_c where deleted=0',
                    field: 'unitpriceamount',
                    callbackMethod: 'getTotalAmountInvested',
                    isDownload:true,
                    filters: [
                        {
                            "field_key": "name",
                            "name": "name",
                            "label": "Name",
                            "type": "name",
                            "value": ""
                        },
                        {
                            field_key: 'from_date',
                            name: 'from_date',
                            label: 'From Date',
                            type: 'date',
                            value: ''
                          },
                        {
                            "field_key": "currency",
                            "name": "currency",
                            "label": "Currency",
                            "type": "enum",
                            "options": {
                                "Rupees": "Rupees",
                                "Dollars": "Dollars",
                            },
                            "value": []
                        },
                    ]
                  },
                  {
                    label: 'Historical Returns Summary',
                    isQuery: false,
                    isApi:true,
                    callbackMethod: 'getTotalAmountInvested',
                    isDownload:true,
                    filters: [
                        {
                            "field_key": "name",
                            "name": "name",
                            "label": "Name",
                            "type": "name",
                            "value": ""
                        },
                        {
                            field_key: 'from_date',
                            name: 'from_date',
                            label: 'From Date',
                            type: 'date',
                            value: ''
                          },
                        {
                            "field_key": "currency",
                            "name": "currency",
                            "label": "Currency",
                            "type": "enum",
                            "options": {
                                "Rupees": "Rupees",
                                "Dollars": "Dollars",
                            },
                            "value": []
                        },
                    ]
                  },
                  ]                
            }
        


    })

    useEffect(()=>{
    //  console.log("nnnnnnnnnnnnnnnnnnnnew",customDashletOptions)
    let finalData = customDashletOptions[customDashletType]
     setCustomTileData(customDashletOptions[customDashletType]);
    },[customDashletOptions])
    return (
        <Grid container spacing={1} >


            <Grid item xs={6}  >

                <TextField
                    select
                    id="custom-dashlet-select"
                    name="custom-dashlet-select"
                    value={customDashletType}
                    label="Custom Dashlet Type"

                    onChange={(e) => setCustomDashletType(e.target.value)}
                    variant="outlined"
                    fullWidth
                    size="small"
                >
                    <MenuItem value="Filter">Filter</MenuItem>
                    <MenuItem value="Form">Form</MenuItem>
                    <MenuItem value="Card">Card</MenuItem>
                    <MenuItem value="Policy List">Policy List</MenuItem>
                    <MenuItem value="Chart">Chart</MenuItem>
                    <MenuItem value="Compare">Compare</MenuItem>
                    <MenuItem value="Table List">Table List</MenuItem>
                    <MenuItem value="Progress Bar">Progress Bar</MenuItem>
                    <MenuItem value="Custom Reports">Custom Reports</MenuItem>
                </TextField>
            </Grid>
            <Grid item xs={6}  >

            {pathOr(null, ['subType'], data)===null? <Button
                    variant="contained"
                    color="primary"
                    // className={classes.button}
                    startIcon={<SaveIcon />}
                    onClick={() => { addDashlet(customDashletType, customDashletOptions[customDashletType])}}
                >
                    Add
                </Button>:null}

            </Grid>

            <Grid item xs={12}  >

                {/* <TextField
                    placeholder="Json Data"
                    variant="outlined"
                    multiline
                    rows={15}
                    size="small"
                    name="jsonData"
                    value={JSON.stringify(customDashletOptions[customDashletType], undefined, 4)
                        }
                    fullWidth
                    onChange={(e) => setCustomDashletOptions({ ...customDashletOptions, [customDashletType]: JSON.parse(e.target.value) })}

                    InputLabelProps={{
                        shrink: true,
                    }}
                /> */}

<JSONInput
    id          = 'jsonData'
    placeholder = {customDashletOptions[customDashletType]}
    // placeholder = {{...customDashletOptions[customDashletType],['result']:[]}}
    locale      = { locale }
    height      = '400px'
    onChange={(val) => setCustomDashletOptions({ ...customDashletOptions, [customDashletType]: val.jsObject })}
/>


            </Grid>
        </Grid>

    );
}